import { Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthorResearchPerfEvalOverview } from '@/module/ResearchPerfEval/AuthorResearchPerfEvalOverview';
import { getResearchPerfEvalOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/research-perf-eval/_layout/$evaluationId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
  loader: async ({ params: { evaluationId }, context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getResearchPerfEvalOptions(evaluationId));
  },
});

function RouteComponent() {
  const { evaluationId } = Route.useParams();
  const { data: evaluation } = useSuspenseQuery(getResearchPerfEvalOptions(evaluationId));
  const userId = Route.useSearch().userId;
  const { currentRole } = useCurrentUser();

  return (
    <Stack>
      {userId != null && (
        <AuthorResearchPerfEvalOverview
          evaluation={evaluation}
          userId={userId}
          canVerifyResearchPerfEval={currentRole != 'AUTHOR'}
          canStartResearchPerfEval={currentRole == 'AUTHOR'}
          currentRole={currentRole}
        />
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
    </Stack>
  );
}
